import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const MY_ACC_URL = `${API_URL}/api/v1/parent/accouunt`;
export const MY_ACC_DETAILS_URL = `${API_URL}/api/v1/parent/parent-acc-detials`;
export const MY_ACCOUNT_DEL_URL = `${API_URL}/api/v1/parent/my-account`;
export const MY_SUBSCRIPTION_URL = `${API_URL}/api/v1/parent/subscription`;
export const MY_SUBSCRIPTION_END_DETAILS_URL = `${API_URL}/api/v1/parent/subscription-end-details`;
export const SUBSCRIPTION_AUTORENEW_URL = `${API_URL}/api/v1/parent/auto-renewal`;
export const REGISTERED_PARENT_URL = `${API_URL}/api/v1/parent/referral-code-parent`;
export const REFERRAL_DISCOUNT_URL = `${API_URL}/api/v1/parent/referral-discount`;
export const TRIAL_PERIOD_URL = `${API_URL}/api/v1/parent/trial-period`;
export const ACC_CHANGE_PWD_URL = `${API_URL}/api/v1/change-password`;

export function getAccountDetails() {
    return axiosInstance({
        url: MY_ACC_DETAILS_URL,
        method: "GET"
    })
}

export function editAccDetails(payload) {
    return axiosInstance({
        url: MY_ACC_URL,
        method: "PUT",
        data: payload
    })
}

export function deleteUserAccount(payload) {
    return axiosInstance({
        url: MY_ACCOUNT_DEL_URL,
        method: "PUT",
        data: payload
    }) 
}

export function userSubscription() {
    return axiosInstance({
        url: MY_SUBSCRIPTION_URL,
        method: "GET"
    })
}

export function userSubscriptionDetails() {
    return axiosInstance({
        url: MY_SUBSCRIPTION_END_DETAILS_URL,
        method: "GET"
    })
}

export function subscriptionAutoRenew(payload) {
    return axiosInstance({
        url: SUBSCRIPTION_AUTORENEW_URL,
        method: "PUT",
        data: payload
    })
}

export function registeredParentList() {
    return axiosInstance({
        url: REGISTERED_PARENT_URL,
        method: 'GET',
        params: {pageNo: 1, itemsPerPage: 1000}
    })
}

export function referralDiscount() {
    return axiosInstance({
        url: REFERRAL_DISCOUNT_URL,
        method: 'GET'
    })
}

export function trialPeriodDataService() {
    return axiosInstance({
        url: TRIAL_PERIOD_URL,
        method: 'GET'
    })
}

export function changeAccPwd(payload) {
    return axiosInstance({
        url: ACC_CHANGE_PWD_URL,
        method: 'POST',
        data: payload
    })
}